<via-loading-spinner *ngIf="loading"></via-loading-spinner>
<via-keyword-filter-bar
    (searchFilters)="searchFiltersByText($event)"
    (clearSearch)="resetSearch()"
    [isDisabled]="selectedCategories.length > 0"></via-keyword-filter-bar>
<div class="e-scrollable-area">
    <h3 class="e-filter-options-heading">
        All Categories
        <div class="e-lowest-level-legend">
            Select only lowest level categories
            <via-info-icon [tooltipText]="lowestLevelTooltip"></via-info-icon>
        </div>
    </h3>
    <via-checkbox-tree
        *ngIf="categoriesTree.length > 0"
        [tree]="categoriesTree"
        (onChange)="selectionChanged()"
        [accordionStyle]="true"
        [triStateCheckboxesEnabled]="true"
        (selectedSingularNodeChange)="onCheckboxStateChange($event)"
        [events]="eventsSubject.asObservable()">
    </via-checkbox-tree>
    <ng-container *ngIf="categoriesTree.length === 0 && !loading">
        <div class="e-no-results-found-text">{{ noResultsMessage }}</div>
    </ng-container>
    <p *ngIf="showError">{{ errorMessage }}</p>
</div>
